import { SimulationMessage } from 'generated-graphql/types';
import { atom } from 'recoil';

export const simulationMessagesAtom = atom<SimulationMessage[]>({
  key: 'messagesState',
  default: []
});

export const simulationIdAtom = atom<string>({
  key: 'simulationIdState',
  default: ''
});
